import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useMemo } from "react";
import { useGetPhoneLineBillingViaPhoneNumber } from "../api/getPhoneLineBillingViaPhoneNumber";

// All your logic is here
export const usePhoneLineBillingDetails = ({phoneNumber}: usePhoneLineBillingDetailsProps) => {
  const getPhoneLinedBillingDetailsQuery = useGetPhoneLineBillingViaPhoneNumber({phoneNumber: phoneNumber});
  const { t } = useTranslation();

  const loadingDone = [getPhoneLinedBillingDetailsQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getPhoneLinedBillingDetailsQuery].some(({ isError }) => isError);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getPhoneLinedBillingDetailsQuery.data ? getPhoneLinedBillingDetailsQuery.data : [];
  const totalRecords = getPhoneLinedBillingDetailsQuery.data ? getPhoneLinedBillingDetailsQuery.data.length : 0;

  const columnData = [
    {
      columnName: "phoneNumber",
      columnDisplayName: "Αριθμός",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "address",
      columnDisplayName: "Διέυθυνση",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "provider",
      columnDisplayName: "Πάροχος",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "oteConType",
      columnDisplayName: "Είδος",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "oteFpa",
      columnDisplayName: "Φ.Π.Α.",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "String",
    }
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);


  return {
    data,
    columns,
    loadingDone,
    t,
    totalRecords,
    errorData
  };
};

interface usePhoneLineBillingDetailsProps {
  phoneNumber: string;
}